import { render, staticRenderFns } from "./RecommenderInformal.vue?vue&type=template&id=6679ee70&"
import script from "./RecommenderInformal.vue?vue&type=script&lang=js&"
export * from "./RecommenderInformal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports